import { render } from "./SimpleLoading.vue?vue&type=template&id=2cf04e41"
import script from "./SimpleLoading.vue?vue&type=script&lang=js"
export * from "./SimpleLoading.vue?vue&type=script&lang=js"

import "./SimpleLoading.vue?vue&type=style&index=0&id=2cf04e41&lang=scss"

import exportComponent from "/home/bas/app_63f4e4a0-71b0-43b1-9be1-8965f2c8b25b/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__